import { OptionDto } from "@/dtos";
import { VehicleAdministratorRole } from "@/helpers/types";

const vehicleAdministratorRol = [
    { value: parseInt(VehicleAdministratorRole.OWNER), label: 'PROPIETARIO' },
    { value: parseInt(VehicleAdministratorRole.SUPERVISOR), label: 'SUPERVISOR' },
    { value: parseInt(VehicleAdministratorRole.DRIVER), label: 'CONDUCTOR' }
] as OptionDto[];

export const getVehicleAdministradorRolOptions = (): OptionDto[] => {
    return vehicleAdministratorRol;
}

export const getVehicleAdministratorRol = (value: number): OptionDto => {
    return vehicleAdministratorRol.find((x) => x.value == value) ?? vehicleAdministratorRol[0];
}

export const getRolVehicleAdministrator = (value: number): VehicleAdministratorRole => {
    switch (value) {
        case 1001:
            return VehicleAdministratorRole.OWNER;
        case 1002:
            return VehicleAdministratorRole.SUPERVISOR;
        case 1003:
            return VehicleAdministratorRole.DRIVER;
        default:
            return VehicleAdministratorRole.OWNER;
    }
}